/**
 * The sidebar's numbers (spec §2): Murojaatlar, Suhbatlar, Bronlar and Vazifalar.
 *
 * The server answers only for keys it has a provider for, so a missing key means "no badge",
 * never zero. The screen refetches on realtime events and on an interval (see `useNavCounts`).
 */
import type { NavCountKey } from "@/features/shell/navigation";
import { apiRequest } from "@/lib/api";

export type NavCounts = Partial<Record<NavCountKey, number>>;

export const navApi = {
  counts: (): Promise<NavCounts> => apiRequest<NavCounts>("/api/nav/counts/"),
};
